// Utilities to generate calendar links

function convertTimestampToISO(time: string) {
  const d = new Date(time);

  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const date = d.getDate().toString().padStart(2, '0');

  const hour = d.getUTCHours().toString().padStart(2, '0');
  const minute = d.getUTCMinutes().toString().padStart(2, '0');
  const second = d.getUTCSeconds().toString().padStart(2, '0');

  return `${year}${month}${date}T${hour}${minute}${second}Z`;
}

function parseLocation(location: any) {
  const street = location.streetAddress;
  const city = location.city;
  const postalCode = location.postalCode;

  return `${street}, ${city}, ${postalCode}`;
}

function composeTitle(location: string) {
  return `Asuntoesittely ${location}`;
}

function composeMessage(showing: any, location: string, url: string) {
  return `<div>Tervetuloa asuntoesittelyyn ${new Date(
    showing.startTimestamp
  ).toLocaleString()}\nkohteessa ${location}.</div>
  <br>
  <div>${url}</div>
  <br>
  <div>Ystävällisin terveisin, OP Koti</div>
  `;
}

function genGoogleCalendarLink(showing: any, loc: any, currentUrl: string) {
  const startTime = convertTimestampToISO(showing.startTimestamp);
  const endTime = convertTimestampToISO(showing.endTimestamp);

  const dates = `${startTime}/${endTime}`;
  const location = parseLocation(loc);
  const text = composeTitle(location);
  const details = composeMessage(showing, location, currentUrl);

  return encodeURI(
    `http://www.google.com/calendar/event?action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}`
  );
}

export { genGoogleCalendarLink };
